module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_c('div', {
    staticClass: "fx fx-y-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.openUrl) + "/index_vmall?mid=" + _vm._s(_vm.userInfo.mid) + "&scope=snsapi_userinfo\n\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qrcode),
      expression: "qrcode"
    }],
    staticClass: "m-t-20 fx"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-20",
    attrs: {
      "title": "商城名称",
      "isMust": true
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fx m-t-20 vmall-type"
  }, [_vm._m(3), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "vmall-pic",
    class: {
      'active': _vm.params.type == 2
    },
    on: {
      "click": function($event) {
        return _vm.handleVmallType(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/vmall.jpg"),
      "width": "56",
      "height": "96"
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('p', {
    staticClass: "type-mane"
  }, [_vm._v("标准版")])]), _vm._v(" "), _c('div', {
    staticClass: " m-l-30"
  }, [_c('div', {
    staticClass: "vmall-simple-pic",
    class: {
      'active': _vm.params.type == 1
    },
    on: {
      "click": function($event) {
        return _vm.handleVmallType(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/vmall_simple.jpg"),
      "width": "56",
      "height": "96"
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('p', {
    staticClass: "type-mane"
  }, [_vm._v("精简版")])])]), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-20",
    attrs: {
      "title": "客服电话",
      "isMust": true
    },
    model: {
      value: (_vm.params.consumer_phone),
      callback: function($$v) {
        _vm.$set(_vm.params, "consumer_phone", $$v)
      },
      expression: "params.consumer_phone"
    }
  }), _vm._v(" "), _vm._m(6)], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-30 fx"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": function($event) {
        return _vm.handleValidation()
      }
    }
  }, [_vm._v("保存配置")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("微信地址")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("微商城预览")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx-fill"
  }, [_c('div', {
    attrs: {
      "id": "qrcode"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fx w120 m-r-5"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("商城模板")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vmall-del"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/vmall.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vmall-simple-del"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/vmall_simple.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_c('div', {
    staticClass: "title fx-shrink fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("售后服务")])]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_c('div', {
    staticClass: "edit-width"
  }, [_c('div', {
    attrs: {
      "id": "after_sale_info",
      "placeholder": "请在这里填写售后服务内容"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-91ed91f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/vmall/Configure.vue
// module id = 876
// module chunks = 0